module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAUCAMAAADWUb86AAAAflBMVEXytcHunq398vT98fPjXnffR2TEHUDn6+4AJkkBJ0oCKEoEKUwLL1E4VnFHYnxnfpNof5NuhJhvhJh1ip17j6GdrLnEHUDKQ2DOV3HV2+HXi5zYHD/Znq3fR2PjXHXl6ezn6+7tlaXwqrfy9Pb29/n66e36+/v76+78/P3////TYSLDAAAACHRSTlPt7vb3+Pz+/upEbsYAAAB7SURBVCjPjc43FsIwFAXRJ2PBkHM0jgTj/W+Qxhwqyf/WU4z4GWcRApgDnPMwL4AjQNVFCDb7z2E7496ESbB8du8VnIbero8SuNVhTjDdsV4Mv/UuRVj6z+Jvk6r3asMSjVqDRJmJ0sIgVWciVxs465saA1nffG7gjW9f/ohYaykvH4gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/lr.png
// module id = 871
// module chunks = 0